import moment from 'moment';
import mapPeCompanyShortFromApi from 'rtkQuery/sharespro/mapper/modules/pe/peCompany/mapPeCompanyShortFromApi';
import mapPaginationListFromApi from 'rtkQuery/sharespro/mapper/shared/mapPaginationListFromApi';
import { ApiPeDealListItem } from 'rtkQuery/sharespro/types/pe/deals/fetchPeDeals';
import { SharesproApiResponse } from 'rtkQuery/sharespro/types/sharesproApiResponse';

const mapPeDealListFromApi = (
  resp: SharesproApiResponse<ApiPaginationListResponse<ApiPeDealListItem>>
): PaginationList<PeDealListItem> => {
  return mapPaginationListFromApi<PeDealListItem, ApiPeDealListItem>(
    resp.data,
    (apiItem) => ({
      id: apiItem.id,
      company: mapPeCompanyShortFromApi(apiItem.company),
      dealStartedAt: moment(apiItem.deal_date_start).toDate(),
      dealEndedAt: apiItem.deal_date_finish
        ? moment(apiItem.deal_date_finish).toDate()
        : null,
      quantity: apiItem.quantity,
      purchasePrice: apiItem.purchase_price,
      salePrice: apiItem.sale_price,
      status: apiItem.status,
      totalAmount: apiItem.sum,
      totalPurchaseAmount: apiItem.buy_sum,
      revenuePercent: apiItem.revenue_pc,
      isAllowToSale: apiItem.is_allowed_to_sale,
    })
  );
};

export default mapPeDealListFromApi;
